import { useDispatch } from "react-redux";
import { addToCart } from "../redux/cartSlice";

const SingleProduct = ({ item }) => {

    const dispatch = useDispatch();

    const handleClick = () => {
        dispatch(addToCart(item));
    };

    return (
        <article className="group">

            
            <div className="relative aspect-[4/5] overflow-hidden rounded-3xl bg-gray-100">

                <img
                    src={item.thumbnail || item.image}
                    alt={item.title}
                    className="h-full w-full object-contain p-6 transition-transform duration-500 group-hover:scale-110"
                />

                
                <div className="absolute left-4 top-4 rounded-full bg-white/90 px-3 py-1 text-xs font-semibold uppercase tracking-wider text-gray-700 backdrop-blur">
                    {item.category}
                </div>

                <div className="absolute right-4 top-4 rounded-full bg-white/90 px-3 py-1 text-xs font-semibold uppercase tracking-wider text-gray-700 backdrop-blur">
                    {item.rating}   {"  "}
                    <span className="text-yellow-500">★</span>
                </div>

                
                <button
                    onClick={handleClick}
                    className="
                        absolute
                        bottom-4
                        left-4
                        right-4
                        translate-y-16
                        rounded-full
                        bg-gray-900
                        px-4
                        py-3
                        text-sm
                        font-semibold
                        text-white
                        opacity-0
                        transition-all
                        duration-300
                        hover:bg-indigo-600
                        group-hover:translate-y-0
                        group-hover:opacity-100
                    "
                >
                    Add To Cart
                </button>

            </div>


            
            <div className="mt-4 flex justify-between">

                <h3 className="line-clamp-2 text-sm font-semibold text-gray-900 dark:text-white md:text-md">
                    {item.title}
                </h3>

                <div className="flex items-center justify-between px-1">

                    <span className="text-sm font-semibold text-indigo-600">
                        ${item.price}
                    </span>

                </div>

            </div>

        </article>
    );
};

export default SingleProduct;